// routes.tsx
import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const WorkPage = lazy(() => import('../pages/work/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const CookiesPage = lazy(() => import('../pages/cookies/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Case Study Pages
const ChiesiPatientFirstPage = lazy(() => import('../pages/work/chiesi-patient-first-clinical-trials/page'));
const ChiesiPatientArchetypesPage = lazy(() => import('../pages/work/chiesi-patient-archetypes/page'));
const ChiesiPatientExperienceFrameworkPage = lazy(() => import('../pages/work/chiesi-patient-experience-framework/page'));
const GSKViiVPatientInsightsPage = lazy(() => import('../pages/work/gsk-viiv-patient-insights/page'));
const AstraZenecaVaccinesPage = lazy(() => import('../pages/work/astrazeneca-vaccines/page'));
const MalariaNoMorePage = lazy(() => import('../pages/work/malaria-no-more/page'));
const GoogleARMentalHealthPage = lazy(() => import('../pages/work/google-ar-mental-health/page'));
const AustralianRedCrossPlasmaPage = lazy(() => import('../pages/work/australian-red-cross-plasma/page'));
const AstraZenecaLiverCancerPage = lazy(() => import('../pages/work/astrazeneca-liver-cancer/page'));
const ConvatecPatientCarePage = lazy(() => import('../pages/work/convatec-patient-care/page'));
const MonashHospitalTeenagersPage = lazy(() => import('../pages/work/monash-hospital-teenagers/page'));
const EastBrunswickMedicalCentrePage = lazy(() => import('../pages/work/east-brunswick-medical-centre/page'));
const CampQualityNewNormalNavigatorPage = lazy(() => import('../pages/work/camp-quality-new-normal-navigator/page'));
const TourismTropicalNorthQueenslandPage = lazy(() => import('../pages/work/tourism-tropical-north-queensland/page'));
const UnitedNationsInnovationToolkitPage = lazy(() => import('../pages/work/united-nations-innovation-toolkit/page'));
const QantasSustainabilityPage = lazy(() => import('../pages/work/qantas-sustainability/page'));
const AdobeSwinburneVulnerableKidsPage = lazy(() => import('../pages/work/adobe-swinburne-vulnerable-kids/page'));
const GoodSamaritanInnDomesticViolencePage = lazy(() => import('../pages/work/good-samaritan-inn-domestic-violence/page'));
const WorldVisionFundingStrategiesPage = lazy(() => import('../pages/work/world-vision-funding-strategies/page'));
const ForRefugeesPage = lazy(() => import('../pages/work/for-refugees/page'));
const AustralianGovernmentChildCarePage = lazy(() => import('../pages/work/australian-government-child-care/page'));
const RMITActivatorPage = lazy(() => import('../pages/work/rmit-activator/page'));
const ANZBankCustomerExperiencePage = lazy(() => import('../pages/work/anz-bank-customer-experience/page'));
const JetstarFlightDelaysPage = lazy(() => import('../pages/work/jetstar-flight-delays/page'));
const MerlinEntertainmentsDigitalGrowthPage = lazy(() => import('../pages/work/merlin-entertainments-digital-growth/page'));
const ShiseidoBeautyEmpowermentPage = lazy(() => import('../pages/work/shiseido-beauty-empowerment/page'));
const DuluxPaintersEcosystemPage = lazy(() => import('../pages/work/dulux-painters-ecosystem/page'));
const AustraliaPostRetailTeamsPage = lazy(() => import('../pages/work/australia-post-retail-teams/page'));
const AustraliaPostMailDeliveryPage = lazy(() => import('../pages/work/australia-post-mail-delivery/page'));
const AustraliaPostInternationalPostingPage = lazy(() => import('../pages/work/australia-post-international-posting/page'));
const AustraliaPostInnovationLabPage = lazy(() => import('../pages/work/australia-post-innovation-lab/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/work',
    element: <WorkPage />,
  },
  {
    path: '/work/chiesi-patient-first-clinical-trials',
    element: <ChiesiPatientFirstPage />,
  },
  {
    path: '/work/chiesi-patient-archetypes',
    element: <ChiesiPatientArchetypesPage />,
  },
  {
    path: '/work/chiesi-patient-experience-framework',
    element: <ChiesiPatientExperienceFrameworkPage />,
  },
  {
    path: '/work/gsk-viiv-patient-insights',
    element: <GSKViiVPatientInsightsPage />,
  },
  {
    path: '/work/astrazeneca-vaccines',
    element: <AstraZenecaVaccinesPage />,
  },
  {
    path: '/work/malaria-no-more',
    element: <MalariaNoMorePage />,
  },
  {
    path: '/work/google-ar-mental-health',
    element: <GoogleARMentalHealthPage />,
  },
  {
    path: '/work/australian-red-cross-plasma',
    element: <AustralianRedCrossPlasmaPage />,
  },
  {
    path: '/work/astrazeneca-liver-cancer',
    element: <AstraZenecaLiverCancerPage />,
  },
  {
    path: '/work/convatec-patient-care',
    element: <ConvatecPatientCarePage />,
  },
  {
    path: '/work/monash-hospital-teenagers',
    element: <MonashHospitalTeenagersPage />,
  },
  {
    path: '/work/east-brunswick-medical-centre',
    element: <EastBrunswickMedicalCentrePage />,
  },
  {
    path: '/work/camp-quality-new-normal-navigator',
    element: <CampQualityNewNormalNavigatorPage />,
  },
  {
    path: '/work/tourism-tropical-north-queensland',
    element: <TourismTropicalNorthQueenslandPage />,
  },
  {
    path: '/work/united-nations-innovation-toolkit',
    element: <UnitedNationsInnovationToolkitPage />,
  },
  {
    path: '/work/qantas-sustainability',
    element: <QantasSustainabilityPage />,
  },
  {
    path: '/work/adobe-swinburne-vulnerable-kids',
    element: <AdobeSwinburneVulnerableKidsPage />,
  },
  {
    path: '/work/good-samaritan-inn-domestic-violence',
    element: <GoodSamaritanInnDomesticViolencePage />,
  },
  {
    path: '/work/world-vision-funding-strategies',
    element: <WorldVisionFundingStrategiesPage />,
  },
  {
    path: '/work/for-refugees',
    element: <ForRefugeesPage />,
  },
  {
    path: '/work/australian-government-child-care',
    element: <AustralianGovernmentChildCarePage />,
  },
  {
    path: '/work/rmit-activator',
    element: <RMITActivatorPage />,
  },
  {
    path: '/work/anz-bank-customer-experience',
    element: <ANZBankCustomerExperiencePage />,
  },
  {
    path: '/work/jetstar-flight-delays',
    element: <JetstarFlightDelaysPage />,
  },
  {
    path: '/work/merlin-entertainments-digital-growth',
    element: <MerlinEntertainmentsDigitalGrowthPage />,
  },
  {
    path: '/work/shiseido-beauty-empowerment',
    element: <ShiseidoBeautyEmpowermentPage />,
  },
  {
    path: '/work/dulux-painters-ecosystem',
    element: <DuluxPaintersEcosystemPage />,
  },
  {
    path: '/work/australia-post-retail-teams',
    element: <AustraliaPostRetailTeamsPage />,
  },
  {
    path: '/work/australia-post-mail-delivery',
    element: <AustraliaPostMailDeliveryPage />,
  },
  {
    path: '/work/australia-post-international-posting',
    element: <AustraliaPostInternationalPostingPage />,
  },
  {
    path: '/work/australia-post-innovation-lab',
    element: <AustraliaPostInnovationLabPage />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/cookies',
    element: <CookiesPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
